import { apiSlice } from '@/features/api/apiSlice';

export type TrackingDomain = {
  id: string;
  domain: string;
  cnameTarget: string;
  verificationStatus: 'verified' | 'failed' | 'pending';
  verifiedAt: string | null;
  lastCheckedAt: string | null;
  certStatus: 'pending' | 'issued' | 'renewing' | 'failed' | 'expired';
  certIssuedAt: string | null;
  certExpiresAt: string | null;
  certLastRenewalAt: string | null;
  certRenewalError: string | null;
  createdAt: string;
};

export type VerifyResult = {
  verified: boolean;
  resolvedTo: string | null;
  expected: string;
  instructions: Array<{ type: string; host: string; value: string; note?: string }>;
};

export type CertRenewResult = {
  status: string;
  expiresAt: string | null;
};

export const trackingDomainsApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listTrackingDomains: b.query<TrackingDomain[], void>({
      query: () => '/tracking-domains',
      providesTags: ['TrackingDomain'],
    }),
    createTrackingDomain: b.mutation<TrackingDomain, { domain: string }>({
      query: (body) => ({ url: '/tracking-domains', method: 'POST', body }),
      invalidatesTags: ['TrackingDomain'],
    }),
    verifyTrackingDomain: b.mutation<VerifyResult, string>({
      query: (id) => ({ url: `/tracking-domains/${id}/verify`, method: 'POST' }),
      invalidatesTags: ['TrackingDomain'],
    }),
    renewTrackingDomainCert: b.mutation<CertRenewResult, string>({
      query: (id) => ({ url: `/tracking-domains/${id}/cert/renew`, method: 'POST' }),
      invalidatesTags: ['TrackingDomain'],
    }),
    deleteTrackingDomain: b.mutation<void, string>({
      query: (id) => ({ url: `/tracking-domains/${id}`, method: 'DELETE' }),
      invalidatesTags: ['TrackingDomain'],
    }),
  }),
});

export const {
  useListTrackingDomainsQuery,
  useCreateTrackingDomainMutation,
  useVerifyTrackingDomainMutation,
  useRenewTrackingDomainCertMutation,
  useDeleteTrackingDomainMutation,
} = trackingDomainsApi;
